export const DO_NOT_TRANSLATE_BY_DEFAULT_COOKIE_NAME = 'do_not_translate_by_default';
export const DEFAULT_MT_COOKIE_DOMAIN = 'fiverr.com';
